import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, CardBody, Modal } from 'react-bootstrap';
import { CastType, IQuery, IWhere, IQuerySelectData, IUploadFilePreviewItem, IStoreReturn, IStoreReturnLine, IStore, ISelectedScannedItem } from '../solution/Interfaces';
import { useAuth } from '../../contexts/AuthContext';
import { formatDateFull } from '../solution/utils/AppUtil';
import { ScanLine, Check, FileText, UserCheck, X, Pencil, ThumbsUp, ArrowUp, Printer, Save, Ban, RotateCcw, CheckCircle, ChevronDown, ChevronUp, UserCog } from 'lucide-react';
import ShowErrorAlert from '../ShowErrorAlert';
import Logo from "../../assets/img/logo.png";
import bkLogo from "../../assets/img/birkenstock_logo.png";
import hdLogo from "../../assets/img/hey_dude.png";
import tbLogo from "../../assets/img/ted_baker.png";
import dcLogo from "../../assets/img/digicape_logo_black.png";
import htLogo from "../../assets/img/hi-tec.svg"; 
import crLogo from "../../assets/img/crocs_logo_new.png";
import okLogo from "../../assets/img/oakley_logo.jpeg";
import uaLogo from "../../assets/img/ua-logo.png"


interface IComponent {
    store: IStore;
    close: () => void;
}


export const StoreReturn:React.FC<IComponent | null> = (props) => {

  const { fetchData, userDetail, responseErrorMessage, showErrorAlert, responseStatus }  = useAuth();
  const queryUrl: string = `${process.env.REACT_APP_BASE_URL}/${"query/data"}`;
  const queryUrlSelectNoCount: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data"}`;
  const fetchStockReturnActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/STORE-RETURN-ACTIONS/run`; 
  const fetchStockReturnLineActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/STORE-RETURN-LINE-ACTIONS/run`; 
  const fetchStockTakeFilePreviewQuertUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/SCAN-FILE-SUMMARY/run`;
  

  const [stockReturnStateFailedTransactions, setStockReturnStateFailedTransactions] = useState<IStoreReturn[]>([]);
  const [stockReturnStateSuccessfulTransactions, setStockReturnStateSuccessfulTransactions] = useState<IStoreReturn[]>([]);
  const [stockReturnLineState, setStockReturnLineState] = useState<IStoreReturnLine[]>([]);
  const [selectedStockReturn, setSelectedStockReturn] = useState<IStoreReturn | null>(null);
  const [selectedFailedStoreReturn, setSelectedFailedStoreReturn] = useState<IStoreReturn | null>(null);
  const [selectedStockReturnValid, setSelectedStockReturnValid] = useState<IStoreReturn | null>(null);
  const [selectedStoreReturnDocNum, setSelectedStoreReturnDocNum] = useState<string>("");
  const [selectedStoreReturnDocNumNotes, setSelectedStoreReturnDocNumNotes] = useState<string>("");
  const [stockReturnNotes, setStockReturnNotes] = useState<string>("");
  const [approvedQty, setApprovedQty] = useState<{ [key: string]: number }>({});

  const [showCreatStockReturnModal, setShowCreatStockReturnModal] = useState<boolean>(false);
  const [showPendingStoreReturnModal, setShowPendingStoreReturnModal] = useState<boolean>(false);
  const [showDeletingStoreReturnModal, setShowDeletingStoreReturnModal] = useState<boolean>(false);
  const [showCancelStoreReturnModal, setShowCancelStoreReturnModal] = useState<boolean>(false);
  const [showEditDocNumNotesModal, setShowEditDocNumNotesModal] = useState<boolean>(false);
  const [showApprovedStockReturnModal, setShowApprovedStockReturnModal] = useState<boolean>(false);
  const [showFailedStoreReturnRerunModal, setShowFailedStoreReturnRerunModal] = useState<boolean>(false);
  const [showFailedStoreReturnHandledModal, setShowFailedStoreReturnHandledModal] = useState<boolean>(false);

  const [submitRefreshData, setSubmitRefreshData] = useState<boolean>(false); 
  const [submitRefreshLineData, setSubmitRefreshLineData] = useState<boolean>(false);
  const [submitRefreshFailedTransactionData, setSubmitRefreshFailedTransactionData] = useState<boolean>(false);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [viewMode, setViewMode] = useState<'manager' | 'scan' | 'view' | 'print' | 'default'>('default'); 

  const [loading, setLoading] = useState<boolean>(false);
  const [lineDataCheckLoading, setLineDataCheckLoading] = useState<boolean>(false);
  const [loadingFailed, setLoadingFailed] = useState<boolean>(false);

  //refs 
  const fileRef = useRef<HTMLInputElement | null>(null);
  const scanRef = useRef<HTMLInputElement | null>(null);
  const docNumNotesRef = useRef<HTMLTextAreaElement | null>(null);


  const [selectedScannedItem, setSelectedScannedItem] = useState<ISelectedScannedItem | null>(null);  
  const [showCustomQuantitySection, setShowCustomQuantitySection] = useState<boolean>(false);
  const [customQuantity, setCustomQuantity] = useState<string>('1');

  const [printTarget, setPrintTarget] = useState<'label' | 'manifest'>('label'); 

  const [editingRowId, setEditingRowId] = useState<string | null>(null);
  const [editedQty, setEditedQty] = useState<Record<string, number>>({}); 
  const [inputDraft, setInputDraft] = useState<Record<string, string>>({});

  const [previewFileUpload, setPreviewFileUpload] = useState<boolean>(false);
  const [previewUploadedFileData, setPreviewUploadedFileData] = useState<IUploadFilePreviewItem[]>([]);
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [previewFailed, setPreviewFailed] = useState<boolean>(false);

  const [shouldResetAfterClose, setShouldResetAfterClose] = useState(false);

  const [expanded, setExpanded] = useState(false);

  const defaultQueryStateScanItem: IQuerySelectData = { appCode: "ares", selectCode: "scan-item",  params: {}};   
  const [querySelectStateScanItem, setQuerySelectStateScanItem] = useState<IQuerySelectData>(defaultQueryStateScanItem);

  // -> failed transactions
  const defaultQueryStateFailedTransactions: IQuerySelectData = {
          appCode: "ares",
          selectCode: "sa-ares-store-return",  
          where: `from_whs = :from_whs AND handled_status IS NOT DISTINCT FROM :handled_status`,  
          orderBy: "",
          params: {'from_whs': `${props?.store.code}`, 'handled_status': "REQUIRED"}
  }; 
  const [querySelectStateFailed, setQuerySelectStateFailed] = useState<IQuerySelectData>(defaultQueryStateFailedTransactions);

  // -> successful transactions
  const defaultQueryStateSuccessfulTransactions: IQuerySelectData = {
          appCode: "ares",
          selectCode: "sa-ares-store-return",  
          where: `from_whs = :from_whs`,  
          orderBy: "",
          params: {'from_whs': `${props?.store.code}`}
  }; 
  const [querySelectStateSuccessful, setQuerySelectStateSuccessful] = useState<IQuerySelectData>(defaultQueryStateSuccessfulTransactions);

  

  //Query Line State
  const [queryLineState, setQueryLineState] = useState<IQuery>({
    tableName: "sa_ares_store_return_line",
    select: [],
    groupBy: [],
    join: [{
      relationship: 'item',
      joinType: "LEFT"
    }],
    orderBy: [ 
        {
            fullColumnName: "created",
            direction: "ASC",
            cast: CastType.TIMESTAMP
        }
    ],
    where:[],
    mainTableOnly: false,
    includeExtraColumns: true,
    includeControlColumns: true,
    modifiedAfter: null,
    touchedBefore: null,
    isDirty: null,
    // pageNum: 0,
    // pageSize: 100,
    frontEndOnly: null
 });

 
  //useeffects
  useEffect(() => {
    setLoading(true); 
    fetchData(queryUrlSelectNoCount, {method:"POST", body: JSON.stringify(querySelectStateSuccessful)}, processDataSuccessful, cleanUpLoader);
  }, [querySelectStateSuccessful, submitRefreshData]);

  
  useEffect(() => {
    if(expanded){
      setLoadingFailed(true); 
      fetchData(queryUrlSelectNoCount, {method:"POST", body: JSON.stringify(querySelectStateFailed)}, processDataFailed, cleanUpLoader);
    }
  }, [querySelectStateFailed, expanded, submitRefreshFailedTransactionData]);

  useEffect(() => {
    if (showCreatStockReturnModal && fileRef.current) {
        fileRef.current.focus();
    }
  }, [showCreatStockReturnModal]);

  useEffect(() => {
    if (showEditDocNumNotesModal && docNumNotesRef.current) {
        docNumNotesRef.current.focus();
    }
  }, [showEditDocNumNotesModal]);

  useEffect(() => {
    if (viewMode === "scan" && scanRef.current) {
        scanRef.current.focus();
    }
  }, [viewMode]);

  useEffect(() => {
    if(selectedStockReturn){
      const queryLine = {...queryLineState}
      queryLine.where = [
          {
              fullColumnName: "doc_num",
              value: selectedStockReturn?.doc_num, 
              operator: "EQ",
              cast: CastType.STRING
          }       
      ]
      setLoading(true); 
      fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryLine)}, processLineData, cleanUpLoader);
    }
  }, [selectedStockReturn, submitRefreshLineData]);

    useEffect(() => {
      if(selectedStockReturnValid){
        const queryLine = {...queryLineState}
        queryLine.where = [
            {
                fullColumnName: "doc_num",
                value: selectedStockReturnValid?.doc_num, 
                operator: "EQ",
                cast: CastType.STRING
            }       
        ]
        setLoading(true); 
        fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryLine)}, processLineData, cleanUpLoader);
      }
  
  }, [selectedStockReturnValid]);

  useEffect(() => {
    const initialApprovedQty: Record<string, number> = {};
  
    stockReturnLineState.forEach((line) => {
      const maxQty = line.qty_on_hand ?? 0;
      const requestedQty = line.qty_requested ?? 0;
      initialApprovedQty[line.item_code] = Math.min(requestedQty, maxQty);
    });
  
    setApprovedQty(initialApprovedQty);
  }, [stockReturnLineState]);

  useEffect(() => {
      if(previewFileUpload && (responseStatus === "400" || responseStatus === "404")){
          setPreviewUploadedFileData([]);
          setPreviewLoading(false);
          setPreviewFailed(true);
      }
  }, [responseStatus, previewFileUpload])

   
  const processDataFailed = (result: any) => {

    const stockReturnFailedTransactions: IStoreReturn[] = [];

    for (const key in result?.data) {
        const item = result.data[key];
        if (item?.data) {
          stockReturnFailedTransactions.push(item.data as IStoreReturn);
        }
    }

    stockReturnFailedTransactions.sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());

    // Collapse table secion if empty reset expand
    if (stockReturnFailedTransactions.length === 0) {
      setExpanded(false);
    }

    setStockReturnStateFailedTransactions(stockReturnFailedTransactions);
  }

  const processDataSuccessful = (result: any) => {
    const stockReturnSuccessfulTransactions: IStoreReturn[] = [];

    for (const key in result?.data) {
        const item = result.data[key];
        if (item?.data) {
          stockReturnSuccessfulTransactions.push(item.data as IStoreReturn);
        }
    }

    stockReturnSuccessfulTransactions.sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());

    setStockReturnStateSuccessfulTransactions(stockReturnSuccessfulTransactions); 
  }


  const processLineData = (result: any) => {

    const stockReturnLines: IStoreReturnLine[] = [];
  
    for(const key in result?.data){
  
        const entry = result.data[key];
        const control = entry.control || {};
        const data = entry.data || {};

        stockReturnLines.push({
            id: control.id,
            created: control.created,
            updated: control.updated ?? null,
            line_num: data.line_num,
            item_name: data["item.name"],
            item_code: data.item_code,
            item_barcode: data["item.barcode"], 
            doc_num: data.doc_num,
            qty_on_hand: data.qty_on_hand,
            qty_approved: data.qty_approved,
            qty_requested: data.qty_requested,
          });
    }

    setStockReturnLineState(stockReturnLines);
  };


  //default clean up loader
  const cleanUpLoader = () => {
     setLoading(false);
     setLineDataCheckLoading(false);
     setLoadingFailed(false);
  }
    

   // Handle file/folder selection
  const handleFolderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
    
      if (file) {
        const isXlsx = file.name.toLowerCase().endsWith(".xlsx");
    
        if (isXlsx) {
          setSelectedFile(file); 
        } else {
          setSelectedFile(null); 
        }
      } else {
        setSelectedFile(null); 
      }
  };

  // Handle Create Stock Return
  const handleCreateStockReturnSubmit = () => {
    if (props?.store?.code && !selectedFile) {
        setLoading(true);
        fetchData(fetchStockReturnActionsQueryUrl, 
          {method:"POST", body: JSON.stringify({ store_code: props?.store?.code, notes: stockReturnNotes })}, 
          (result: any, status: string) =>  { 
              if(status === "200"){
                setSelectedStockReturn(result);
                setViewMode("scan");
              }
          }, cleanUpLoader);

    }else if (props?.store?.code && selectedFile) {

         // how to do a multipe part form posts javascript  
         const formData = new FormData();
         formData.append('file', selectedFile);
         formData.append('j1', new Blob([JSON.stringify({ store_code: props?.store.code, notes: stockReturnNotes })], { type: 'application/json' }));

         const headers = new Headers();
         headers.append("Content-Type", "multipart/formdata");

         setLoading(true);
         fetchData(fetchStockReturnActionsQueryUrl, 
          {method:"POST", body: formData, headers: headers }, 
          (result: any, status: string) =>  { 
              if(status === "200"){
                // Causes refresh on data  
                setSubmitRefreshData(prev => !prev);
              }
          }, cleanUpLoader);
        
    }else{
        return; // Prevent further execution if the code is not available
    }

     // Reset fileRef after submission
     setSelectedFile(null);
      if (fileRef.current) {
          fileRef.current.value = ''; 
      }

     setStockReturnNotes("");
     setPreviewFileUpload(false);
     setPreviewUploadedFileData([]);
     setPreviewFailed(false);
  }

   //handle view button when clicked
   const handleViewClick = (storeReturn : IStoreReturn) => {
     setViewMode('view'); // Switch to view mode
     setSelectedStockReturn(storeReturn);
   }

   //handle scan button when clicked
   const handleScanClick = (storeReturn : IStoreReturn) => {
        setViewMode('scan'); // Switch to Scan mode
        setSelectedStockReturn(storeReturn);
   }

    // Add the event handler for "Enter" key press
    const handleScanKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, docNum: string) => {
        if (event.key === 'Enter') {
            event.preventDefault();  // Prevent default behavior (if needed)
            handleScanSubmit(docNum); 
        }
    };


    const handleScanSubmit = (docNum: string) => {
        setLoading(true);
        const scanValueItemCode = scanRef.current?.value.trim();
        if (!docNum || !scanValueItemCode) return;

        const queryPayload = {
          ...querySelectStateScanItem,
          params: { ...querySelectStateScanItem.params, scan_code: scanValueItemCode },
        };

        let shouldRunLineFetch = true;

        fetchData( queryUrlSelectNoCount,
          { method: "POST", body: JSON.stringify(queryPayload)},
          (result: any, status: string) => {
            if (status === "200") {
              const item = result?.data?.[0]?.data;
              const id = result?.data?.[0]?.id;

              if (item && id) {

                const itemGroup = item.item_group;

                const scannedItem: ISelectedScannedItem = {
                  id,
                  barcode: item.barcode,
                  item_code: item.item_code,
                  item_group: itemGroup,
                  name: item.name,
                  product_code: item.product_code,
                };

                setSelectedScannedItem(scannedItem);

                if (itemGroup === "Jibbitz") {
                  setShowCustomQuantitySection(true);
                  shouldRunLineFetch = false; // Don't run line fetch for Jibbitz
                }
              }
            }

            // Only run line fetch if allowed
            if (shouldRunLineFetch) {
              fetchData(fetchStockReturnLineActionsQueryUrl,
                { method: "POST", body: JSON.stringify({ doc_num: docNum, item_code: scanValueItemCode, qty_requested: 1 })},
                (result: any, status: string) => {
                  if (status === "200") {
                    setSubmitRefreshLineData((prev) => !prev);
                  }
                },
                cleanUpLoader
              );
            } 
            
            else {
              cleanUpLoader(); // still clean up if skipping line fetch
            }
          }
        );

        if (scanRef.current) {
          scanRef.current.value = "";
        }
    };

    
    const handleQuantitySubmit = () => {

      if (!selectedScannedItem || !selectedStockReturn?.doc_num) return;

      const { item_code, barcode } = selectedScannedItem;

      const parsedQty = Math.max(1, parseInt(customQuantity) || 1);

      const payload = {
        doc_num: selectedStockReturn.doc_num,
        qty_requested: parsedQty,
        item_code: item_code || barcode,
      };

      setLoading(true);

       fetchData(fetchStockReturnLineActionsQueryUrl,
        { method:"POST", body: JSON.stringify(payload)}, 
        (result: any, status: string) =>  { 
          if(status === "200"){
              setShowCustomQuantitySection(false);
              setSelectedScannedItem(null);
              setCustomQuantity('1');
              setSubmitRefreshLineData(prev => !prev); 
          }
        }, cleanUpLoader);
    };


   //handle pending stock return button when clicked
   const handlePendingStockReturnClick = (storeReturn : IStoreReturn) => {
      setViewMode('default'); // Switch to default mode
      setSelectedStoreReturnDocNum(storeReturn.doc_num);
      setSelectedStockReturnValid(storeReturn);
      setShowPendingStoreReturnModal(true);
      setLineDataCheckLoading(true)
   }

   //handle the submit for setting pending store return
   const handlePendingStockReturnSubmit = () => {

      const isValid = selectedStoreReturnDocNum !== "" && stockReturnLineState.length > 0;

      if (!isValid) return;

      setLoading(true);

      const resetIBTState = () => { setSelectedStoreReturnDocNum(""); setSelectedStockReturnValid(null); setStockReturnLineState([]); };

      fetchData(fetchStockReturnActionsQueryUrl,{ method: "POST", body: JSON.stringify({ doc_num: selectedStoreReturnDocNum,  status: "PENDING" })},
        (result: any, status: string) => {
          resetIBTState();
          if (status === "200") {
            setSubmitRefreshData(prev => !prev);
          }
        },
        cleanUpLoader
      );
   }


  //handle deleting stock return button when clicked
  const handleDeletingStockReturnClick = (storeReturn : IStoreReturn) => {
    setViewMode('default'); // Switch to default mode
    setShowDeletingStoreReturnModal(true);
    setSelectedStoreReturnDocNum(storeReturn.doc_num);
  }
  
    //handle the submit for setting deleted store return
    const handleDeleteStockReturnSubmit = () => {
        if(selectedStoreReturnDocNum !== ""){
           setLoading(true);
           fetchData(fetchStockReturnActionsQueryUrl, 
             {method:"POST", body: JSON.stringify({ doc_num: selectedStoreReturnDocNum,  status: "DELETED"})}, 
             (result: any, status: string) =>  { 
                 if(status === "200"){
                   // Causes refresh on data  
                   setSubmitRefreshData(prev => !prev);
                 }
             }, cleanUpLoader);
             setSelectedStoreReturnDocNum("");
        }else{
          return; 
        }
    }


  //handle manager approval view button when clicked
   const handleManagerApprovalViewClick = (storeReturn : IStoreReturn) => {
    setViewMode('manager'); // Switch to manager mode
    setSelectedStockReturn(storeReturn);
  }

  const handlePrintStockReturnClick = (storeReturn : IStoreReturn) => {
    setViewMode('print'); // Switch to print mode
    setSelectedStockReturn(storeReturn);
  }

  //handle the failed transaction click rerun
  const handleFailedStoreReturnRerunClick = (storeReturn : IStoreReturn) => {
    setViewMode('default'); // Switch to default mode
    setSelectedFailedStoreReturn(storeReturn);
    setShowFailedStoreReturnRerunModal(true);
  }

  //handle cancel transaction view 
  const handleCancelView = (storeReturn : IStoreReturn) => {
    setViewMode('default'); // Switch to default mode
    setShowCancelStoreReturnModal(true);
    setSelectedStoreReturnDocNum(storeReturn.doc_num);
  }

  //CANCEL STOCK TAKE Record
  const handleCancelTransactionSubmit = (user_id: string, document_number: string, document_type: string, transaction_number: string) => { 
      if (user_id === "" || document_number === "" || document_type === "") return;

        const formData  = { 
            user_id: user_id, 
            document_number: document_number, 
            document_type: document_type, 
            transaction_number: transaction_number 
        }

        setLoading(true);
        fetchData(`${process.env.REACT_APP_BASE_URL}/functions/CANCEL-DOCUMENT/run`, 
          {method:"POST", body: JSON.stringify(formData)}, 
          (result: any, status: string) =>  { 
              if(status === "200"){
                // Causes refresh on data  
                setSubmitRefreshData(prev => !prev);
              }
          }, cleanUpLoader);
          setSelectedStoreReturnDocNum("");
   }

  const handleFailedStoreReturnRerunResetClick = () => {
    setSelectedFailedStoreReturn(null);
    setShowFailedStoreReturnRerunModal(false);
  }

  const handleFailedStoreReturnRerunSubmit = () => {
     if(selectedFailedStoreReturn?.doc_num !== "" && selectedFailedStoreReturn?.function_call_id != null){
       setLoading(true);
       const notes = selectedFailedStoreReturn?.notes ?? "";
      fetchData(`${process.env.REACT_APP_BASE_URL}/functionCalls/${selectedFailedStoreReturn?.function_call_id}/rerun`, 
      {method:"POST", body: JSON.stringify({ handledMessage: notes })}, 
      (result: any, status: string) =>  { 
          if(status === "200"){
             setSelectedFailedStoreReturn(null);
             setSubmitRefreshFailedTransactionData(prev => !prev); //trigger refresh on success 
          }else{
            setSelectedFailedStoreReturn(null);
          }
          
      }, cleanUpLoader);
         
     } else {
        return; 
     }
  }

  //handle the failed transaction click handled
  const handleFailedStoreReturnHandledClick = (storeReturn : IStoreReturn) => {
    setViewMode('default'); // Switch to default mode
    setSelectedFailedStoreReturn(storeReturn); 
    setShowFailedStoreReturnHandledModal(true);
  }

  const handleFailedStoreReturnHandledResetClick = () => {
    setSelectedFailedStoreReturn(null);
    setShowFailedStoreReturnHandledModal(false);
  }


  const handleFailedStoreReturnHandledSubmit = () => {
     if(selectedFailedStoreReturn?.doc_num !== "" && selectedFailedStoreReturn?.function_call_id != null){
      setLoading(true);
      const notes = selectedFailedStoreReturn?.notes ?? "";
      fetchData(`${process.env.REACT_APP_BASE_URL}/functionCalls/${selectedFailedStoreReturn?.function_call_id}/handle`, 
      {method:"POST", body: JSON.stringify({ notes })}, 
      (result: any, status: string) =>  { 
          if(status === "200"){
             setSelectedFailedStoreReturn(null);
             setSubmitRefreshFailedTransactionData(prev => !prev); //trigger refresh on success
          }else{
            setSelectedFailedStoreReturn(null);
          }
          
      }, cleanUpLoader);
         
     } else {
        return; 
     }
  }
  

  //handle open edit selectd doc num notes 
  const handleOpenEditDocNumNotesClick = (storeReturn: IStoreReturn) => {
    setShowEditDocNumNotesModal(true); // open modal 
    setSelectedStoreReturnDocNumNotes(storeReturn?.notes ?? ""); //set the notes
    setSelectedStoreReturnDocNum(storeReturn?.doc_num); //set the doc num
  }

  const handleUpdateDocNumNotesSubmit = () => {
     if(selectedStoreReturnDocNum !== ""){
        setLoading(true);
        fetchData(fetchStockReturnActionsQueryUrl, 
          {method:"POST", body: JSON.stringify({ doc_num: selectedStoreReturnDocNum, notes: selectedStoreReturnDocNumNotes })}, 
          (result: any, status: string) =>  { 
              if(status === "200"){

                // Shadow copy and update notes
                if (selectedStockReturn && selectedStockReturn.doc_num === selectedStoreReturnDocNum) {
                    setSelectedStockReturn({
                    ...selectedStockReturn,
                    notes: selectedStoreReturnDocNumNotes,
                    });
                } 

                setSelectedStoreReturnDocNumNotes(""); //set the notes
                setSelectedStoreReturnDocNum(""); //set the doc num
              }else{
                setSelectedStoreReturnDocNumNotes(""); //set the notes
                setSelectedStoreReturnDocNum(""); //set the doc num
              }
             
          }, cleanUpLoader);
    
     }else{
        return; 
     }
  }

  //console.log(`These are the approved qtys:`, approvedQty);
  const handleApprovedStoreReturnClick = (storeReturn: IStoreReturn) => {
    setShowApprovedStockReturnModal(true); // open modal 
    setSelectedStoreReturnDocNum(storeReturn?.doc_num); //set the doc num
  }

  const handleApprovedStoreReturnSubmit = () => {
    if(selectedStoreReturnDocNum !== ""){

     const docData = {
        doc_num: selectedStoreReturnDocNum,
        approved: approvedQty, 
        status: "APPROVED",
     };

     fetchData(fetchStockReturnActionsQueryUrl, 
        {method:"POST", body: JSON.stringify(docData)}, 
        (result: any, status: string) =>  { 
            if(status === "200"){
              handleBackToReceipts();
              setSelectedStoreReturnDocNum(""); //set the doc num
            }
        });
    }else{
        return;
    }
  }

    
  const handleEditClick = (id: string, initialQty: number) => {
    setEditingRowId(id);
    setEditedQty(prev => ({ ...prev, [id]: initialQty }));
    setInputDraft(prev => ({ ...prev, [id]: initialQty.toString() }));
  };

  const handleQtyDraftChange = (id: string, value: string) => {
    setInputDraft(prev => ({ ...prev, [id]: value }));
  };

  const handleBlur = (id: string) => {
      const draftValue = inputDraft[id];
      const parsed = parseInt(draftValue, 10);
      setEditedQty(prev => ({ ...prev, [id]: isNaN(parsed) ? 0 : parsed }));
  };

  const handleSaveClick = (id: string) => {
        const qty = editedQty[id];
        const item_code = stockReturnLineState.find(line => line.id === id)?.item_code;
        const doc_num = selectedStockReturn?.doc_num;

        if (!item_code || qty === undefined || doc_num === undefined) return;

        const payload = {
          doc_num,
          item_code,
          qty_requested: qty,
          mode: 'exact'
        };


        // Perform your save operation here (e.g., API call)
        fetchData(fetchStockReturnLineActionsQueryUrl,
        { method:"POST", body: JSON.stringify(payload)}, 
        (result: any, status: string) =>  { 
            if(status === "200"){
                setSubmitRefreshLineData(prev => !prev); 
                setEditingRowId(null); // exit edit mode
                setEditedQty({});
                setInputDraft({});
            }
        }, cleanUpLoader);
    };

    //handles the back to stock returns.
    const handleBackToReceipts = () => {
        setViewMode('default');
        setSelectedStockReturn(null);
        setApprovedQty({});
        setShowCustomQuantitySection(false);
        setSelectedScannedItem(null);
        setCustomQuantity('1');
        setEditingRowId(null); // exit edit mode
        setEditedQty({});
        setInputDraft({});
        fetchData(queryUrlSelectNoCount, {method:"POST", body: JSON.stringify(querySelectStateSuccessful)}, processDataSuccessful, cleanUpLoader); //recall success transactions
        
    }


    const handleCloseForm = () => {
      setSelectedScannedItem(null);
      setCustomQuantity('1');
      setShowCustomQuantitySection(false); 
    };

   
    const userRole = userDetail?.roles?.includes("HQ") ? "HQ" : "All";
    const showHQFields = (viewMode === "manager" || viewMode === "view") && userRole === "HQ";
    const showActions = selectedStockReturn?.status === "OPEN";

    // Base columns are always 5
    const baseColSpan = 5;
    const extraCols = showHQFields ? 2 : 0;
    const actionCol = showActions ? 1 : 0;

    const totalColSpan = baseColSpan + extraCols + actionCol;

    const DisabledScanBtn = () => {
        return (
            <span className="btn h-100 d-flex align-items-center gap-1" title="Scan"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
             >
             <ScanLine style={{ width: "17px", height: "17px", color: "#6c757d" }} />
           </span>
        ) 
    } 

    const DisabledCheckBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Submit Stock Return"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <Check style={{ width: "17px", height: "17px",  color: "#6c757d" }} />
        </span>
       )
    } 

    const DisabledDeleteBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Set To Delete"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <X style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
    } 


    const DisabledHQAceesBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Manage Approval"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <UserCheck style={{ width: "17px", height: "17px",  color: "#6c757d" }} />
        </span>
       )
    } 

    const DisabledApprovalBtn = () => {
      return (
      <span className="btn h-100 d-flex align-items-center gap-1" title="Approve Return"
            style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
        >
       <ThumbsUp style={{ width: "17px", height: "17px",  color: "#6c757d" }} />
      </span>
     )
  } 

  const DisabledCancelTransactionBtn = () => {
      return (
      <span className="btn h-100 d-flex align-items-center gap-1" title="Cancel Transaction"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
          <Ban style={{ width: "17px", height: "17px", color: "#6c757d" }} />
      </span>
      )
  } 

    const DisabledPrintBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Print"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <Printer style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
    } 

    const DisabledEditQtyBtn = () => {
              return (
              <span className="btn h-100 d-flex align-items-center gap-1" title="Edit Quantity"
                  style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
              >
              <Pencil style={{ width: "17px", height: "17px", color: "#6c757d" }} />
              </span>
          )
    } 

    const DisabledSaveQtyBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Save Quantity"
                style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
            >
            <Save style={{  width: "17px", height: "17px",  color: "#6c757d" }}/>
        </span>
        )
    } 

    //Handling the file preview
    const handleFilePreview = () => {
      if(selectedFile){

        setPreviewFileUpload(true);
        setPreviewLoading(true);

        // how to do a multipe part form posts javascript  
        const formData = new FormData();
        formData.append('file', selectedFile);

        const headers = new Headers();
        headers.append("Content-Type", "multipart/formdata");

        fetchData(fetchStockTakeFilePreviewQuertUrl, 
        { method:"POST", body: formData, headers: headers }, 
        ((result: any, status: string) =>  { 
          if(status === "200"){
              setPreviewLoading(false);
              setPreviewUploadedFileData(result || []);
              setPreviewFailed(false);
          }else{
              setPreviewUploadedFileData([]);
              setPreviewLoading(false);
              setPreviewFailed(true);
            }
        })); 

      }else{
        return;
      }
  }

  //handling the file preview cancel reset 
  const handleCancelFilePreview = () => {
          setPreviewFileUpload(false);
          setPreviewUploadedFileData([]);
          setStockReturnNotes("");
          setPreviewFailed(false);

          // Reset fileRef after submission
          setSelectedFile(null);
          if (fileRef.current) {
              fileRef.current.value = ''; 
          }
  }



  const handleCloseCreateStockReturnModal = () => {
    setSelectedFile(null);
    if (fileRef.current) {
      fileRef.current.value = '';
    }
    setStockReturnNotes('');
    setShowCreatStockReturnModal(false);
    setPreviewFileUpload(false);
    setPreviewUploadedFileData([]);
    setPreviewFailed(false);
  };

  	

  // let customerLogo = Logo;
  const { src: customerLogo, width: customerLogoWidth } = getCustomerLogo();

  function getCustomerLogo() {
    switch (process.env.REACT_APP_COMPANY) {
      case "ares-bk":
        return { src: bkLogo, width: "150px" };
      case "ares-hd":
        return { src: hdLogo, width: "100px" }; // 80
      case "ares-tb":
        return { src: tbLogo, width: "150px" };
      case "digicape":
        return { src: dcLogo, width: "80px" };
      case "hi-tec":
        return { src: htLogo, width: "80px" };
      case "ares-cr":
        return { src: crLogo, width: "160px" };
      case "ares-ok":
        return { src: okLogo, width: "100px" };
      case "ares-ua":
        return { src: uaLogo, width: "80px" };
      default:
        return { src: Logo, width: "80px" };
    }
  }

  const physicalAddress = process.env.REACT_APP_ARES_M24L_3PL_ADDRESS;
  const postalCode = process.env.REACT_APP_ARES_M24L_3PL_POSTAL_CODE;
  const cityName = process.env.REACT_APP_ARES_M24L_3PL_CITY;
  const countryName = process.env.REACT_APP_ARES_M24L_3PL_COUNTRY;


  const handlePrint = () => {
       window.print();
   }


 

  const toggleExpanded = () => setExpanded((prev) => !prev);

  const thStyle = {
    border: '1px solid #deebed',
    color: "#6c757d",
    padding: "8px",
    whiteSpace: "nowrap" as const,
    backgroundColor: "#f8f9fa",
  };

  const thNewStyle = {
    borderBottom: "1px solid #dee6ed",
    borderRight: "1px solid #dee6ed",
    borderTop: "1px solid #dee6ed",
    color: "#6c757d",
    padding: "8px",
    whiteSpace: "nowrap" as const,
    backgroundColor: "#f8f9fa",
  };

  const tdStyle = {
    borderBottom: "1px solid #dee6ed",
    borderRight: "1px solid #dee6ed",
    padding: "8px",
    whiteSpace: "nowrap" as const,
 };




  return (
    <>
    { showErrorAlert && <ShowErrorAlert message={responseErrorMessage} /> } 
     <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
              <Card.Title className="mb-0">{`Store Return [${props?.store.name}]`}</Card.Title>
              { viewMode === "default" && (
              <button
                className="btn p-1 d-flex align-items-center justify-content-center"
                onClick={toggleExpanded}
                title={expanded ? "Hide failed transactions" : "Show failed transactions"}
                style={{ border: "1px solid #c10000", background: "transparent", borderRadius: "50%", color: "#c10000", width: "22px", height: "22px"}}
              >
                {expanded ? (
                   <ChevronUp size={20} strokeWidth={2.2} />
                ) : (
                   <ChevronDown size={20} strokeWidth={2.2} />
                )}
              </button>
              )}
            </Card.Header>
            <CardBody>

                <div className="d-flex gap-1">
                    <button
                        className="btn btn-secondary h-100"
                        style={{width: viewMode === 'default' ? "120px" : "160px"}}
                        onClick={() => {
                            if (viewMode === 'default') {
                                props?.close(); 
                            } else {
                                handleBackToReceipts();
                            }
                        }}
                        >
                        { viewMode === 'default' ? "Back to Store" : "Back To Store Return" }
                    </button>
                    {viewMode === 'default' && (
                    <button
                        className="btn btn-secondary h-100"
                        onClick={() => setShowCreatStockReturnModal(true)}
                     >
                       Create Store Return
                     </button>
                    )}
               </div>

                    {expanded && stockReturnStateFailedTransactions.length > 0 && viewMode === "default" && (
                      <div style={{border: "1px solid #c10000" , padding: '0px 4px', marginBottom: '14px', marginTop: '14px', borderRadius: '5px'}}>
                      <h5 className="mt-2 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1">
                           Failed Transactions: 
                      </h5>
                   
                    <div
                    style={{
                      maxHeight: stockReturnStateFailedTransactions.length > 10 ? "450px" : "unset", // change based on count
                      overflowY: stockReturnStateFailedTransactions.length > 10 ? "auto" : "visible",
                      marginBottom: "4px",
                      position: "relative",
                      backgroundColor: "#fff", // helps hide any pixel bleed
                      borderBottom: "1px solid #dee6ed",
                    }}
                  >
                  <table className="table table-bordered  mb-0" style={{ borderCollapse: "separate", borderSpacing: 0, width: "100%" }}>
                    <thead
                      className="table-light"
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        backgroundColor: "#f8f9fa",
                        boxShadow: "0 2px 2px -1px rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <tr>
                        <th style={{ ...thNewStyle, width: "160px"}}>Doc Num</th>
                        <th style={thNewStyle}>Message</th>
                        <th style={thNewStyle}>Last Run</th>
                        <th style={{ ...thNewStyle, width: "100px"}}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                       { loading && viewMode === "default" ? (
                        <>
                          <tr>
                              <td colSpan={3} className="text-center">
                              <div className="spinner-border" role="status">
                                  <span className="visually-hidden">Loading...</span>
                              </div>
                              </td>
                          </tr>
                        </>
                        ) : (
                          <>
                      {!selectedStockReturn && viewMode === "default" && stockReturnStateFailedTransactions.map((stockReturn: IStoreReturn, index) => (
                        <tr key={index}>
                          <td style={tdStyle}>{stockReturn.doc_num}</td>
                          <td style={{...tdStyle,
                                maxWidth: "300px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}>
                            {stockReturn.extended_message}
                          </td>
                          <td style={tdStyle}>{formatDateFull(stockReturn.completed_at ?? "")}</td>
                          <td style={tdStyle} className="d-flex gap-1">
                            {/* Rerun */}
                            <button className="btn btn-secondary d-flex align-items-center gap-1" title="Rerun"
                              onClick={() => handleFailedStoreReturnRerunClick(stockReturn)}
                            >
                              <RotateCcw  style={{ width: "17px", height: "17px" }}/>
                            </button>

  

                            {/* Handled */}
                            <button className="btn btn-secondary d-flex align-items-center gap-1" title="Handled"
                             onClick={() => handleFailedStoreReturnHandledClick(stockReturn)}
                            >
                              <CheckCircle style={{ width: "17px", height: "17px" }} />
                            </button>
                          </td>
                        </tr>
                     
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div style={{marginBottom: "3px", marginLeft: "10px", color: "#c10000" }}>
                    <small className="text-muted fw-bolder">Total Failed Transactions: {stockReturnStateFailedTransactions.length}</small>
                </div>
                   
              </div> 
              )}

              
               <br></br>                                       
               <div>
                  { /* Stock Return Table Start */ }
                  <div style={{ overflowY: "auto" , marginBottom: "4px", position: "relative", backgroundColor: "#fff", borderBottom: "1px solid #dee6ed" }}>
                  <table className="table table-bordered">
                            <thead>                           
                                <tr>
                                    <th style={thStyle}>Doc Number</th>
                                    <th style={thStyle}>IBO Number </th>
                                    <th style={thStyle}>From Warehouse</th>
                                    <th style={thStyle}>To Warehouse</th>
                                    <th style={thStyle}>Status</th>
                                    <th style={thStyle}>Created</th>
                                    <th style={thStyle}>Notes</th>
                                    <th style={{...thStyle, width: '150px'}}>Total Qty Approved</th>
                                    <th style={{...thStyle, width: '150px'}}>Total Qty Requested</th>
                                    <th style={{...thStyle, width: '250px'}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                               { loading && viewMode === "default" ? (
                                 <>
                                    <tr>
                                        <td colSpan={9} className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        </td>
                                    </tr>
                                 </>
                                 ) : (
                                    <>
                                     {!selectedStockReturn && viewMode === "default" && stockReturnStateSuccessfulTransactions.map((stockReturn: IStoreReturn) => (
                                      <tr key={stockReturn.id}>
                                        <td style={tdStyle}>{stockReturn.doc_num}</td>
                                        <td style={tdStyle}>{stockReturn.transfer_request_doc_num}</td>
                                        <td style={tdStyle}>{stockReturn.from_whs}</td>
                                        <td style={tdStyle}>{stockReturn.to_whs}</td>
                                        <td style={tdStyle}>{stockReturn.status}</td>
                                        <td style={tdStyle}>{formatDateFull(stockReturn.created)}</td>
                                        <td style={tdStyle} title={stockReturn?.notes ?? ""}>
                                            <div style={{ 
                                                whiteSpace: "nowrap", 
                                                overflow: "hidden", 
                                                textOverflow: "ellipsis", 
                                                maxWidth: "150px" 
                                            }}>
                                                {stockReturn.notes}
                                            </div>
                                        </td>
                                        <td style={tdStyle} className="text-end">{stockReturn.total_qty_approved}</td>
                                        <td style={tdStyle} className="text-end">{stockReturn.total_qty_requested}</td>
                                        <td style={tdStyle} className="d-flex gap-1">

                                            { stockReturn.status === "OPEN" ? (
                                               <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Scan'
                                                onClick={() => handleScanClick(stockReturn)}
                                                >
                                                  <ScanLine style={{ width: "17px", height: "17px" }} /> 
                                               </button>
                                            ) : (
                                                <DisabledScanBtn/>
                                            )} 

                                           { stockReturn.status === "OPEN" ? (
                                               <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Submit Store Return'
                                                 onClick={() => handlePendingStockReturnClick(stockReturn)}
                                                >
                                                 <Check style={{ width: "17px", height: "17px" }} /> 
                                               </button>
                                            ) : (
                                                <DisabledCheckBtn/>
                                            )} 

                                            <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='View'
                                              onClick={() => handleViewClick(stockReturn)}
                                            >
                                                <FileText style={{ width: "17px", height: "17px" }}  /> 
                                            </button>

                                            {(stockReturn.status === "OPEN" || (stockReturn.status === "PENDING" && userRole === "HQ")) ? (
                                                 <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Set To Delete'
                                                   onClick={() => handleDeletingStockReturnClick(stockReturn)}
                                                  >
                                                  <X style={{ width: "17px", height: "17px" }} /> 
                                                 </button>
                                                ) : (
                                                <DisabledDeleteBtn/>
                                            )}  

                                            {userRole === "HQ" && (stockReturn.status === "PENDING" || stockReturn.status === "OPEN" || stockReturn.status === "DELETED") ? (
                                            <button
                                                className="btn btn-secondary h-100 d-flex align-items-center gap-1"
                                                title="Manage Approval"
                                                onClick={() => handleManagerApprovalViewClick(stockReturn)}
                                            >
                                                <UserCheck style={{ width: "17px", height: "17px" }} />
                                            </button>
                                            ) : (
                                              <DisabledHQAceesBtn />
                                            )}

                                            <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Print'
                                              onClick={() => handlePrintStockReturnClick(stockReturn)}
                                              >
                                              <Printer style={{ width: "17px", height: "17px" }} /> 
                                            </button>

                                          { (stockReturn.status === "OPEN" || stockReturn.status === "PENDING")  && userDetail?.roles?.includes("cancel_documents") ? (
                                             <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Cancel Transaction'
                                               onClick={() => handleCancelView(stockReturn)}
                                              >
                                                <Ban style={{ width: "17px", height: "17px", }}  /> 
                                              </button>
                                          ) : (
                                            <DisabledCancelTransactionBtn/>
                                          )} 
                                        
                                        </td>
                                     </tr>
                                   ))}
                                 </>
                                )}

                                {selectedStockReturn && viewMode !== "default" &&
                                    <>
                                        <tr key={selectedStockReturn.id}>
                                            <td style={tdStyle}>{selectedStockReturn.doc_num}</td>
                                            <td style={tdStyle}>{selectedStockReturn.transfer_request_doc_num}</td>
                                            <td style={tdStyle}>{selectedStockReturn.from_whs}</td>
                                            <td style={tdStyle}>{selectedStockReturn.to_whs}</td>
                                            <td style={tdStyle}>{selectedStockReturn.status}</td>
                                            <td style={tdStyle}>{formatDateFull(selectedStockReturn.created)}</td>
                                            <td style={tdStyle} title={selectedStockReturn?.notes ?? ""}>
                                            <div style={{ 
                                                whiteSpace: "nowrap", 
                                                overflow: "hidden", 
                                                textOverflow: "ellipsis", 
                                                maxWidth: "150px" 
                                            }}>
                                                {selectedStockReturn.notes}
                                            </div>
                                           </td>
                                            <td style={tdStyle} className="text-end">{selectedStockReturn.total_qty_approved}</td>
                                            <td style={tdStyle} className="text-end">{selectedStockReturn.total_qty_requested}</td>
                                            <td style={tdStyle}>
                                            { /* disable if status it deleted */ }
                                                {viewMode === 'manager' && 
                                                 <div className='d-flex gap-1'>
                                                  <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Edit Notes'
                                                  onClick={() => handleOpenEditDocNumNotesClick(selectedStockReturn)}
                                                  >
                                                   <Pencil style={{ width: "17px", height: "17px" }}  /> 
                                                  </button>

                                                  {selectedStockReturn.status === "PENDING" ? (
                                                    <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Approve Return'
                                                    onClick={() => handleApprovedStoreReturnClick(selectedStockReturn)}
                                                    >
                                                    <ThumbsUp style={{ width: "17px", height: "17px" }}   /> 
                                                    </button>
                                                  ) : (
                                                      <DisabledApprovalBtn/>
                                                  )}
                                                 </div>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                        <td colSpan={10} style={{...tdStyle, textAlign: 'center' }}>
                                          {viewMode === 'view' || viewMode === 'manager' || viewMode === 'print' ? null : (
                                            <>
                                              {selectedScannedItem && showCustomQuantitySection ? (
                                                  <form
                                                    onSubmit={(e) => {
                                                      e.preventDefault();
                                                      handleQuantitySubmit();
                                                    }}
                                                    className="p-3 border rounded bg-light"
                                                    style={{ display: 'inline-block', textAlign: 'left', minWidth: '600px' }}
                                                  >
                                                    <div className="mb-3 position-relative">
                                                      <div className="d-flex justify-content-between align-items-center">
                                                        <h6 className="mb-0" style={{ fontWeight: 600 }}>Scanned Item Details</h6>
                                                        <button
                                                          type="button"
                                                          className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                          style={{ width: '28px', height: '28px' }}
                                                          onClick={handleCloseForm}
                                                          aria-label="Close"
                                                        >
                                                          <X style={{ width: "17px", height: "17px" }}  />
                                                        </button>
                                                      </div>
                                                      <hr className="my-2" />

                                                      <div className="row">
                                                        <div className="col-md-6 mb-2">
                                                          <label className="form-label mb-0"><strong>Name:</strong></label>
                                                          <div className="form-control-plaintext">{selectedScannedItem.name}</div>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                          <label className="form-label mb-0"><strong>Item Group:</strong></label>
                                                          <div className="form-control-plaintext">{selectedScannedItem.item_group}</div>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                          <label className="form-label mb-0"><strong>Item Code:</strong></label>
                                                          <div className="form-control-plaintext">{selectedScannedItem.item_code}</div>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                          <label className="form-label mb-0"><strong>Barcode:</strong></label>
                                                          <div className="form-control-plaintext">{selectedScannedItem.barcode}</div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <div className="d-flex align-items-center">
                                                        <label htmlFor="custom_quantity" className="form-label mb-0 me-2"><strong>Quantity:</strong></label>
                                                         <input
                                                            type="number"
                                                            id="custom_quantity"
                                                            name="custom_quantity"
                                                            min={1}
                                                            value={customQuantity}
                                                            onChange={(e) => setCustomQuantity(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ width: '100px' }}
                                                          />
                                                      </div>

                                                      <button type="submit" className="btn btn-dark btn-sm ms-3">
                                                        Save Qauntity
                                                      </button>
                                                    </div>
                                                  </form>
                                              ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                  <span style={{ marginRight: '10px' }}>Scan</span>
                                                  <input
                                                    ref={scanRef}
                                                    id="scan_code"
                                                    name="scan_code"
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control form-control-md w-25"
                                                    style={{ margin: 0 }}
                                                    onKeyDown={(e) => handleScanKeyDown(e, selectedStockReturn.doc_num)}
                                                  />
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                }       
                            </tbody>
                      </table>
                   </div>
                  { /* Stock Return Table End */ }

                  {selectedStockReturn && viewMode !== "default" && viewMode !== "print" &&
                    <div style={{overflowY: "auto", marginBottom: "4px", position: "relative", backgroundColor: "#fff", borderBottom: "1px solid #dee6ed"}}>
                            <table className="table table-bordered">
                                <thead>                           
                                    <tr>
                                        <th style={thStyle}>Line No.</th>
                                        <th style={thStyle}>Item Name</th>
                                        <th style={thStyle}>Item Code</th>
                                        <th style={thStyle}>Item Barcode</th>
                                        <th style={{...thStyle, width: '120px'}}>Qty Requested</th>
                                         
                                        {showHQFields && (
                                            <>
                                                <th style={{...thStyle, width: '120px'}}>Qty On Hand</th>
                                                <th style={{...thStyle, width: '120px'}}>Qty Approved</th>
                                            </>
                                        )}
                                        {selectedStockReturn?.status === "OPEN" && (
                                            <th style={{...thStyle, width: '50px'}}>Actions</th>
                                        )}
                                    </tr>                                                             
                                </thead>
                                <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={totalColSpan} className="text-center">
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    stockReturnLineState.map((stockReturnLine: IStoreReturnLine) => {
                                        const maxQuantity = stockReturnLine.qty_on_hand ?? 0;
                                        const requestedQuantity = stockReturnLine.qty_requested ?? 0;
                                        const approvedValue = approvedQty[stockReturnLine.item_code];

                                        const isEditing = editingRowId === stockReturnLine.id;
                                      
                                        // this is what is shown in the input
                                        const displayQty =
                                          approvedValue !== undefined
                                            ? approvedValue
                                            : Math.min(requestedQuantity, maxQuantity);
                                      
                                        const isRequestedHigher = requestedQuantity > maxQuantity;
                                        const qtyMismatch = displayQty !== maxQuantity;
                                      
                                        return (
                                          <tr key={stockReturnLine.id}>
                                            <td style={tdStyle}>{stockReturnLine.line_num}</td>
                                            <td style={tdStyle}>{stockReturnLine.item_name}</td>
                                            <td style={tdStyle}>{stockReturnLine.item_code}</td>
                                            <td style={tdStyle}>{stockReturnLine.item_barcode}</td>
                                            <td style={{...tdStyle, position: "relative"}} className="text-end">
                                              {isEditing ? (
                                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    style={{ maxWidth: "80px", fontSize: "0.85rem", padding: "0.25rem" }}
                                                    value={inputDraft[stockReturnLine.id] ?? ''}
                                                    onChange={(e) => handleQtyDraftChange(stockReturnLine.id, e.target.value)}
                                                    onBlur={() => handleBlur(stockReturnLine.id)}
                                                    autoFocus
                                                    onClick={(e) => (e.target as HTMLInputElement).select()}
                                                    onFocus={(e) => (e.target as HTMLInputElement).select()}
                                                    />
                                                  </div>
                                                ) : (
                                                    stockReturnLine.qty_requested
                                                )}

                                                {viewMode === "manager" && isRequestedHigher && (
                                                  <div
                                                    style={{
                                                      position: "absolute",
                                                      top: 2,
                                                      right: 4,
                                                      backgroundColor: "#f0f0f0",
                                                      borderRadius: "50%",
                                                      padding: "2px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <ArrowUp color="red"  strokeWidth={3} style={{ width: "10px", height: "10px" }} />
                                                  </div>
                                                )}
                                            </td>
                                      
                                            {showHQFields && (
                                              <>
                                                <td style={tdStyle}>{stockReturnLine.qty_on_hand}</td>
                                                <td style={{...tdStyle, position: "relative", paddingRight:'30px'}}>
                                                  { viewMode === "manager" ? (
                                                <>
                                                  <input
                                                    type="number"
                                                    style={{ width: "100%", }}
                                                    value={displayQty}
                                                    min={0}
                                                    max={maxQuantity}
                                                    onChange={(e) => {
                                                      const newQty = parseInt(e.target.value, 10) || 0;
                                                      if (newQty > maxQuantity) return;
                                                      setApprovedQty((prevState) => ({
                                                        ...prevState,
                                                        [stockReturnLine.item_code]: newQty,
                                                      }));
                                                    }}
                                                  />
                                                  <div
                                                    style={{
                                                      position: "absolute",
                                                      top: 2,
                                                      right: 4,
                                                      backgroundColor: "#f0f0f0",
                                                      borderRadius: "50%",
                                                      padding: "2px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    {qtyMismatch && (<X color={"orange"}  strokeWidth={3} style={{ width: "10px", height: "10px" }} />)}
                                                    
                                                    
                                                  </div>
                                                  </>
                                                    ) : (
                                                        <>{displayQty}</>
                                                    )}
                                                </td>
                                              </>
                                            )}

                                             {selectedStockReturn?.status === "OPEN" && (
                                                  <td  className='d-flex gap-1'>
                                                    {isEditing ? (
                                                        <>
                                                          { !inputDraft[stockReturnLine.id]?.trim() ? (
                                                                <DisabledSaveQtyBtn/>
                                                            ) : (

                                                            <button className="btn btn-secondary h-100 d-flex align-items-center gap-1"  title="Save Quantity"
                                                                onClick={() => handleSaveClick(stockReturnLine.id)}
                                                              >
                                                               <Save style={{ width: "17px", height: "17px" }}  />
                                                            </button>
                                                                
                                                            )
                                                        }
                                                          <button className="btn btn-secondary h-100 d-flex align-items-center gap-1"  title="Cancel"
                                                              onClick={() => setEditingRowId(null)}
                                                            >
                                                              <X style={{ width: "17px", height: "17px" }}  />
                                                          </button>
                                                        </>
                                                    ) : editingRowId === null ? (
                                                           <button className="btn btn-secondary h-100 d-flex align-items-center gap-1"  title="Edit Quantity"
                                                              onClick={() => handleEditClick( stockReturnLine.id, stockReturnLine.qty_requested ?? 0)}
                                                            >
                                                              <Pencil style={{ width: "17px", height: "17px" }}  />
                                                          </button>
                                                    ) : (<DisabledEditQtyBtn/>) }
                                              </td>
                                             )}
                                          </tr>
                                        );
                                      })
                                  )}                                                                                                                                                      
                                </tbody>
                            </table>
                          </div>
                        }

                         { selectedStockReturn && viewMode === 'print' && 
                            <div>
                                <h5 className="mt-4 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1 d-flex justify-content-between align-items-center">
                                  <span>Select Print Option:</span>
                                </h5>
                                <div className='d-flex gap-1'>
                                  <button onClick={() => setPrintTarget('label')}  className={`btn ${printTarget === 'label' ? 'btn-primary' : 'btn-secondary'}`}>Label</button>
                                  <button onClick={() => setPrintTarget('manifest')} className={`btn ${printTarget === 'manifest' ? 'btn-primary' : 'btn-secondary'}`}>Manifest</button>
                                </div>
                              </div>
                          }

                            { selectedStockReturn && viewMode === 'print' && (
                            <>
                                <h5 className="mt-4 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1 d-flex justify-content-between align-items-center">
                                <span>{printTarget === 'label' ? 'Print Label' : 'Print Manifest'}</span>
                                <button
                                    className="btn btn-secondary d-flex align-items-center gap-1"
                                    title={printTarget === 'label' ? 'Print Label' : 'Print Manifest'}
                                    onClick={handlePrint}
                                >
                                    <Printer style={{ width: "17px", height: "17px" }} />
                                </button>
                                </h5>
        
                                <div className="preview-print-container">
                                {printTarget === 'label' && (
                                    <div id="print-label" className="print-sticker">
                                    {/* Top Row: Logo + Info */}
                                    <div className="store-logo-section">
                                      {/* Logo */}
                                      <div className='store-logo'>
                                        <img src={customerLogo} style={{ width: customerLogoWidth }} />
                                      </div>

                                      {/* Info */}
                                      <div className='store-ref-section'>
                                        <p style={{ fontWeight: 'bold', margin: 0, fontSize: "18px" }}>Store Return</p>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                          <span style={{ fontWeight: 'bold' }}>Ref:</span>
                                          <span>{selectedStockReturn.doc_num}</span>
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                          <span style={{ fontWeight: 'bold' }}>IBO Number:</span>
                                          <span>{selectedStockReturn.transfer_request_doc_num}</span>
                                        </div>
                                      </div>
                                     </div>
        
                                       {/* Warehouse Details */}
                                      <div style={{ marginTop: '10px', marginBottom: '10px', width: '100%' }}>
                                        {[
                                          { label: 'From Warehouse:', value: props?.store.name },
                                          { label: 'To Warehouse:', value: selectedStockReturn.to_whs },
                                          { label: 'Total Items:', value: selectedStockReturn.total_qty_approved },
                                          { label: 'To Warehouse Address:', value: physicalAddress },
                                          { label: 'Postal Code:', value: postalCode },
                                          { label: 'City:', value: cityName },
                                          { label: 'Country:', value: countryName },
                                        ].map(({ label, value }) => (
                                          <div key={label}
                                            style={{ display: 'flex',  gap: '4px', flexWrap: 'wrap', ...(label === 'To Warehouse Address:' ? { marginTop: '12px' } : {}), }}
                                          >
                                            <span style={{ fontWeight: 'bold' }}>{label}</span>
                                            <span>{value}</span>
                                          </div>
                                        ))}
                                      </div>
        
                                        {/* Notes */}
            
                                        {/* Notes */}
                                        <div className="notes-section">
                                          <p style={{ margin: 0 }}>Notes: {selectedStockReturn.notes}</p>
                                        </div>
                                    </div>
                                )}
        
                                {printTarget === 'manifest' && (
                                    <div id="print-label" className="print-sticker">
                                    {/* Manifest content goes here */}
                                    {/* Top Row: Logo + Info */}
                                        <div className="store-logo-section">
                                        {/* Logo */}
                                        <div className='store-logo'>
                                          <img src={customerLogo} style={{ width: customerLogoWidth }} />
                                        </div>

                                        {/* Info */}
                                        <div className='store-ref-section'>
                                          <p style={{ fontWeight: 'bold', margin: 0, fontSize: "18px" }}>Store Return</p>
                                          <div style={{ display: 'flex', gap: '8px' }}>
                                            <span style={{ fontWeight: 'bold' }}>Ref:</span>
                                            <span>{selectedStockReturn.doc_num}</span>
                                          </div>
                                          <div style={{ display: 'flex', gap: '8px' }}>
                                          <span style={{ fontWeight: 'bold' }}>IBO Number:</span>
                                          <span>{selectedStockReturn.transfer_request_doc_num}</span>
                                        </div>
                                        </div>
                                      </div>
                                       
        
                                       {/* Warehouse Details */}
                                      <div style={{ marginTop: '10px', marginBottom: '10px', width: '100%' }}>
                                        {[
                                          { label: 'From Warehouse:', value: props?.store.name },
                                          { label: 'To Warehouse:', value: selectedStockReturn.to_whs },
                                          { label: 'Total Items:', value: selectedStockReturn.total_qty_approved },
                                          { label: 'To Warehouse Address:', value: physicalAddress },
                                          { label: 'Postal Code:', value: postalCode },
                                          { label: 'City:', value: cityName },
                                          { label: 'Country:', value: countryName },
                                        ].map(({ label, value }) => (
                                          <div key={label}
                                            style={{ display: 'flex',  gap: '4px', flexWrap: 'wrap', ...(label === 'To Warehouse Address:' ? { marginTop: '12px' } : {}), }}
                                          >
                                            <span style={{ fontWeight: 'bold' }}>{label}</span>
                                            <span>{value}</span>
                                          </div>
                                        ))}
                                      </div>
        
        
                                        {/* Adding the Items: label */}
                                    <div style={{ marginTop: '12px', width: '100%' }}>
                                        <span style={{ fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Items Manifest:</span>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                                        <thead>
                                            <tr>
                                            <th style={{ textAlign: 'left', padding: '4px', borderBottom: '1px solid #ccc' }}>Code</th>
                                            <th style={{ textAlign: 'left', padding: '4px', borderBottom: '1px solid #ccc' }}>Name</th>
                                            <th style={{ textAlign: 'right', padding: '4px', borderBottom: '1px solid #ccc' }}>Quantity</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {stockReturnLineState.map((storeReturnLine: IStoreReturnLine) => (
                                            <tr key={storeReturnLine.id}>
                                                <td style={{ padding: '4px 8px' }}>{storeReturnLine.item_code}</td>
                                                <td style={{ padding: '4px 8px' }}>{storeReturnLine.item_name}</td>
                                                <td style={{ padding: '4px 8px', textAlign: 'right' }}>{storeReturnLine.qty_approved}</td>
                                            </tr>
                                            ))}
                                        </tbody>
                                        </table>
                                    </div>
        
                                        {/* Notes */}
                                        <div className="notes-section">
                                          <p style={{ margin: 0 }}>Notes: {selectedStockReturn.notes}</p>
                                        </div>
                                    </div>
                                )}
                                </div>
                            </>
                            )}
                          
               </div>
            </CardBody>


                 {/* Modal Create Store Return - Start */}
                 <>
                   <Modal show={showCreatStockReturnModal} onHide={handleCloseCreateStockReturnModal}>
                        <Modal.Header closeButton>
                           <Modal.Title>{`Creating Store Return [${props?.store.name}]`}</Modal.Title>
                          </Modal.Header>
                        <Modal.Body>
                        {showErrorAlert && previewFileUpload && <ShowErrorAlert message={responseErrorMessage} /> } 
                         {previewFileUpload ? (
                          <div style={{ width: '100%' }}>
                              <div className="d-flex justify-content-between align-items-center mt-3 mb-2 border-bottom pb-1">
                              <h5 className="text-uppercase text-secondary fw-bolder mb-0">File Preview</h5>
                              {!previewLoading && previewUploadedFileData.length > 0 && (
                                  <div className="fw-bolder text-end text-nowrap" style={{ fontSize: "0.85rem", color: "#333" }}>
                                  Total Qty: {previewUploadedFileData.reduce((acc, cur) => acc + (cur.count || 0), 0)}
                                  </div>
                              )}
                              </div>
                              <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd" }}>
                              <table className="table table-bordered table-sm">
                                  <thead className="table-light">                           
                                      <tr>
                                          <th style={{ color: 'gray' }}>Item Name</th>
                                          <th style={{ color: 'gray' }}>Item Code</th>
                                          <th style={{ color: 'gray' }}>Item Barcode</th>
                                          <th style={{ color: 'gray' }}>Qty</th>
                                      </tr>                                                             
                                  </thead>
                                  <tbody>
                                  {previewLoading ? (
                                      <tr>
                                          <td colSpan={4} className="text-center">
                                              <div className="spinner-border" role="status">
                                                  <span className="visually-hidden">Loading...</span>
                                              </div>
                                          </td>
                                      </tr>
                                  ) : (
                                      previewUploadedFileData.length > 0 && previewUploadedFileData.map((previewLine: IUploadFilePreviewItem) => {
                                          return (
                                          <tr key={previewLine.barcode}>
                                              <td style={{ maxWidth: "120px" }}>
                                                  <span title={previewLine.name ?? ""} style={{ display: "inline-block", maxWidth: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", verticalAlign: "middle"}}>
                                                   {previewLine.name}
                                                  </span>
                                              </td>
                                              <td>{previewLine.itemCode}</td>
                                              <td>{previewLine.barcode}</td>
                                              <td style={{ textAlign: 'right' }}>{previewLine.count}</td>
                                          </tr>
                                          );
                                      })
                                      )}
                                  </tbody>
                                  </table>
                              </div>
                          </div>
                         ) : (
                          <>
                          <div className='informational-message-section'>
                            <strong>Note:</strong> You can proceed without uploading a file. Simply click 
                            <strong> Create </strong> to skip this step and scan your items directly in the interface. 
                            The system will guide you through entering or capturing the necessary information on the next screen.
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                                <label htmlFor="file_codes" style={{ marginBottom: '6px', fontWeight: 'bold', marginLeft: '4px' }}>
                                   Upload File:
                                  <span style={{ color: '#c0392b', fontWeight: 'normal', marginLeft: '8px' }}>
                                      * Optional – Only .xlsx files supported
                                  </span>
                               </label>
                            <input ref={fileRef} id="file_codes" name="file_codes" type="file" accept=".xlsx" className="form-control form-control-md w-80" onChange={handleFolderChange} />
                            <label htmlFor="file_codes" style={{ marginBottom: '6px', fontWeight: 'bold', marginLeft: '4px', marginTop: '8px' }}>
                                 Leave Notes:
                                <span style={{ color: '#c0392b', fontWeight: 'normal', marginLeft: '8px' }}>
                                    * Optional 
                                </span>
                            </label>
                            <textarea
                                id="store_return_notes"
                                name="store_return_notes"
                                className="form-control form-control-md w-80"
                                value={stockReturnNotes}
                                onChange={(e) => setStockReturnNotes(e.target.value)}
                            />
                        </div>
                        </>
                        )}
                        </Modal.Body>
                        <Modal.Footer>

                            {/* Main Action Button */}
                            {selectedFile === null || previewFileUpload ? (
                                <Button variant="primary" disabled={(previewFileUpload && previewFailed)}
                                onClick={() => {  setShowCreatStockReturnModal(false); handleCreateStockReturnSubmit(); }}
                                >
                                 { selectedFile ? "Upload" : " Create" } 
                                </Button>
                            ) : (
                                <Button variant="primary" onClick={handleFilePreview}>
                                Preview
                                </Button>
                            )}
        
                            {/* Cancel Button */}
                            <Button variant="secondary" onClick={previewFileUpload ? handleCancelFilePreview : handleCloseCreateStockReturnModal} >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                 </> 
                {/* Modal Create Store Return - End */}

                  {/* Modal Set Pending Store Return - Start */}
                    <>
                      <Modal
                        show={showPendingStoreReturnModal}
                        onHide={() => { setShowPendingStoreReturnModal(false); setShouldResetAfterClose(true);}}
                        onExited={() => {
                          if (shouldResetAfterClose) {
                            setSelectedStoreReturnDocNum('');
                            setSelectedStockReturnValid(null);
                            setStockReturnLineState([]);
                            setShouldResetAfterClose(false);
                          }
                        }}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{`Confirm [${selectedStoreReturnDocNum}] As Valid To Process.`}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                            { lineDataCheckLoading ? (
                              <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px" }} >
                                  <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                  <p style={{ marginTop: "10px", fontWeight: 600 }}>
                                    Transaction Processing... Please wait. 
                                  </p>
                              </div>
                            ) : (selectedStoreReturnDocNum === '' || stockReturnLineState.length === 0) ? (
                              <div className="informational-message-section">
                                <strong>Note:</strong> Unable to send the document. At least one line must be saved to it before submission.
                              </div>
                            ) : (
                              <p>Are you sure you would like to Submit this Store Return?</p>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            disabled={selectedStoreReturnDocNum === '' || stockReturnLineState.length === 0}
                            onClick={() => {
                              handlePendingStockReturnSubmit();
                              setShowPendingStoreReturnModal(false);
                              setShouldResetAfterClose(true);
                            }}
                          >
                            Confirm
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={() => {
                              setShowPendingStoreReturnModal(false);
                              setShouldResetAfterClose(true);
                            }}
                          >
                            Cancel
                          </Button>
                        </Modal.Footer>
                      </Modal>
        
                    </>
                {/* Modal Set Pending Store Return  - End */}


                  { /* Cancel Transactions */ }
                  <>
                  <Modal show={showCancelStoreReturnModal} onHide={() => {
                    setShowCancelStoreReturnModal(false); 
                 
                    }}>
                          <Modal.Header closeButton>
                          <Modal.Title> Store Return : [ {selectedStoreReturnDocNum} ] </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="informational-message-section">
                                <p>
                                  <strong>Note:</strong> You are about to <strong>cancel this transaction</strong>. 
                                  Clicking <strong>Confirm</strong> will permanently cancel the record and any associated processes. 
                                  Closing this modal or clicking <strong>Cancel</strong> will <strong>abort the cancellation</strong> and leave the transaction unchanged.
                                </p>
                              </div>
                          </Modal.Body>
                          <Modal.Footer>
                          <Button variant="primary" onClick={() => { 
                            setShowCancelStoreReturnModal(false);
                            handleCancelTransactionSubmit(
                                userDetail?.id ?? "",
                                selectedStoreReturnDocNum,
                                "store_return",
                                ""
                              ); 
                              } }>
                              Confirm
                          </Button>
                          <Button variant="secondary" onClick={() => {
                            setShowCancelStoreReturnModal(false);
                  
                        
                            } }>
                              Cancel
                          </Button>
                          </Modal.Footer>
                      </Modal>
                  </> 
                


                  {/* Modal Delete Store Return - Start */}
                  <>
                   <Modal show={showDeletingStoreReturnModal} onHide={() => { setShowDeletingStoreReturnModal(false); }}>
                        <Modal.Header closeButton>
                           <Modal.Title>{`Set [${selectedStoreReturnDocNum}] To Deleted State`}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                            <p>Are you sure you would like to delete this store return?</p>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="primary" onClick={() => { setShowDeletingStoreReturnModal(false);  handleDeleteStockReturnSubmit(); } }>
                            Confirm
                        </Button>
                        <Button variant="secondary" onClick={() => { setShowDeletingStoreReturnModal(false); } }>
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>
                 </> 
                {/* Modal Delete Store Return - End */}


                {/* Modal Updated Selected Doc Num Notes - Start */}
                <>
                   <Modal show={showEditDocNumNotesModal} onHide={() => { setShowEditDocNumNotesModal(false); }}>
                        <Modal.Header closeButton>
                           <Modal.Title>{`Update [${selectedStoreReturnDocNum}] Notes`}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                            <label htmlFor="file_codes" style={{ marginBottom: '6px', fontWeight: 'bold', marginLeft: '4px' }}>
                                Update Notes:
                            </label>
                            <textarea
                                ref={docNumNotesRef}
                                id="doc_num_notes"
                                name="doc_num_notes"
                                className="form-control form-control-md w-80"
                                value={selectedStoreReturnDocNumNotes}
                                onChange={(e) => setSelectedStoreReturnDocNumNotes(e.target.value)}
                                />
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="primary" onClick={() => { setShowEditDocNumNotesModal(false); handleUpdateDocNumNotesSubmit(); } }>
                            Confirm
                        </Button>
                        <Button variant="secondary" onClick={() => { setShowEditDocNumNotesModal(false); } }>
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>
                 </> 
                {/* Modal Updated Selected Doc Num Notes - End */}


                  {/* Modal Approve Store Return - Start */}
                  <>
                   <Modal show={showApprovedStockReturnModal} onHide={() => { setShowApprovedStockReturnModal(false); }}>
                        <Modal.Header closeButton>
                           <Modal.Title>{`Approved [${selectedStoreReturnDocNum}]`}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                            <p>Are you sure you would like to approve this store return?</p>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="primary" onClick={() => { setShowApprovedStockReturnModal(false); handleApprovedStoreReturnSubmit(); }}>
                            Confirm
                        </Button>
                        <Button variant="secondary" onClick={() => { setShowApprovedStockReturnModal(false); } }>
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>
                 </> 
                {/* Modal Approve Store Return - End */}


                   {/* Modal Failed Transaction Rerun - Start */}
                  <>
                      <Modal show={showFailedStoreReturnRerunModal} onHide={handleFailedStoreReturnRerunResetClick}>
                          <Modal.Header closeButton>
                              <Modal.Title>{`Rerun Failed [${selectedFailedStoreReturn?.doc_num}] Transaction`}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                              <p>Are you sure you would like to rerun this transaction?</p>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                          <Button variant="primary" onClick={() => { setShowFailedStoreReturnRerunModal(false); handleFailedStoreReturnRerunSubmit(); } }>
                              Confirm
                          </Button>
                          <Button variant="secondary" onClick={handleFailedStoreReturnRerunResetClick}>
                              Cancel
                          </Button>
                          </Modal.Footer>
                      </Modal>
                    </> 
                  {/*  Modal Failed Transaction Rerun - End */}


                  {/* Modal Failed Transaction Handled - Start */}
                    <>
                      <Modal show={showFailedStoreReturnHandledModal} onHide={handleFailedStoreReturnHandledResetClick}>
                          <Modal.Header closeButton>
                              <Modal.Title>{`Handle Failed [${selectedFailedStoreReturn?.doc_num}] Transaction`}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                              <p>Are you sure you would like to mark this transaction as handled?</p>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                          <Button variant="primary" onClick={() => { setShowFailedStoreReturnHandledModal(false); handleFailedStoreReturnHandledSubmit(); } }>
                              Confirm
                          </Button>
                          <Button variant="secondary" onClick={handleFailedStoreReturnHandledResetClick}>
                              Cancel
                          </Button>
                          </Modal.Footer>
                      </Modal>
                    </> 
                  {/*  Modal Failed Transaction Handled - End */}

       </Card>

    </>
   )
}


